import { Component } from '@angular/core';

@Component({
  selector: 'app-curriculam',
  templateUrl: './curriculam.component.html',
  styleUrls: ['./curriculam.component.scss']
})
export class CurriculamComponent {

}
